<div class="master">
    <h2>Preset Message Definition</h2>
    <app-mat-data-grid
        class="page-data-grid"
        [formValid]="cannedMessageForm.valid"
        [(dataSource)]="filteredCannedMessageData"
        [header]="header"
        [displayedColumns]="[
        'message',
        'group',
        'updatedDate',
        'updater',
        'created',
        'creator'
        ]"
        [columnNames]="[
        'Message',
        'Group',
        'Last Updated',
        'Updated By',
        'Created',
        'Created By'
        ]"
        [columnFormatters]="{'group': formatGroupFunction, 'message': formatMessageLength}"
        [editDefinition]="{
            message: message,
            group: group
        }"
        [pageSizeOptions]="[5, 10, 15]"
        [buttonConfig]="{
        edit: { show: editable },
        delete: { show: editable },
        create: { show: !editing },
        loading: { show: true,  template: loading}
        }"
        [objectBluePrint]="blueprint"
        (buttonClick)="handleButtonEvent($event)"
    >
    </app-mat-data-grid>
</div>

<!-- header -->
<ng-template #header>
    <span id="header" fxLayout="row" fxLayoutAlign="center">
        <div>Filter by LOB:</div>
        <select [(ngModel)]="LOBFilter" [disabled]="editing" (ngModelChange)="applyFilter(LOBFilter)">
            <option value="">No Filter</option>
            <option
              class="custom-option"
              *ngFor="let lob of LOBs"
              [ngValue]="lob[1]"
            >
              {{ lob[0] }}
            </option>
          </select>
    </span>
</ng-template>

<ng-template  #loading>
<mat-spinner *ngIf="!editable" diameter=50></mat-spinner>
</ng-template>

<ng-template let-element #message>
    <div class="message">{{this.editMessage}}</div>
    <form [formGroup]="cannedMessageForm" hidden="true">
        <input
            type="text"
            [(ngModel)]="this.editMessage"
            formControlName="message"
        />
    </form>
    <div><button (click)="openModal()" mat-raised-button color="primary">Edit</button></div>
</ng-template>

<ng-template let-element #group>
    <form [formGroup]="cannedMessageForm">
      <select [(ngModel)]="element.group" formControlName="group">
        <option
          class="custom-option"
          *ngFor="let group of filteredGroups"
          [ngValue]="group.groupId"
        >
          {{ group.groupName }}
        </option>
      </select>
    </form>
  </ng-template>